import React from "react";
import { Add } from "@mui/icons-material";
import { HeaderButton } from "../button/HeaderButton";
import { ComponentType } from "../../constants";
import { useComponentTemplateDialog } from "../../contexts/TemplateDialogContext";
import { ComponentTemplateDto } from "@growth-machine-llc/stridist-api-client";
import { JourneyAnchors } from "../../constants";
import { Box } from "@mui/material";

export interface CreateComponentTemplateButtonProps {
  disabled?: boolean;
  className?: string;
  useThemePalette?: boolean;
  componentType?: ComponentType;
  children?: React.ReactNode;
}
export function CreateComponentTemplateButton(
  props: CreateComponentTemplateButtonProps,
) {
  const {
    disabled = false,
    className,
    useThemePalette = true,
    componentType,
    children,
  } = props;

  const { openDialog } = useComponentTemplateDialog();

  const handleOpenTemplateDialog = React.useCallback(() => {
    openDialog(
      ComponentTemplateDto.fromJS({
        title: "",
        content: "[]",
        type: componentType,
        habitPrompt: "",
        image: "",
      }),
    );
  }, [openDialog]);

  return (
    <Box className={JourneyAnchors.COMPONENT_TEMPLATE_ADD_BUTTON}>
      <HeaderButton
        startIcon={<Add />}
        onClick={handleOpenTemplateDialog}
        disabled={disabled}
        className={className}
        useThemePalette={useThemePalette}
      >
        {children}
      </HeaderButton>
    </Box>
  );
}
